export function QuickAnswers({ question, onSelect }) {
  if (!question?.quick_answers?.length) return null;

  return (
    <div style={{ padding: '0 1rem 0.75rem' }}>
      <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '0.5rem', paddingLeft: '0.25rem' }}>
        Quick answers:
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {question.quick_answers.map((answer, i) => (
          <button
            key={i}
            onClick={() => onSelect(answer)}
            class="tap-active"
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              borderRadius: '12px',
              border: '1px solid var(--sage)',
              color: 'var(--sage)',
              background: 'white',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'background 0.15s ease',
              fontFamily: 'inherit',
            }}
            onMouseOver={(e) => { e.currentTarget.style.background = 'rgba(110,127,79,0.05)'; }}
            onMouseOut={(e) => { e.currentTarget.style.background = 'white'; }}
          >
            {answer.label}
          </button>
        ))}
      </div>
    </div>
  );
}
